module.exports = __webpack_public_path__ + "media/images/creatives-banner-03aa906a254d3662fef019d3c1ab1bf3.png";